import { Link, useLocation } from "react-router-dom";

const TABS = [
  { label: "Overview", to: "/robots/humanoid" },
  { label: "Industrial", to: "/robots/humanoid#industrial" },
  { label: "Commercial", to: "/robots/humanoid#commercial" },
  { label: "Healthcare & Senior Care", to: "/robots/humanoid/healthcare" },
  { label: "Research & Education", to: "/robots/humanoid#research" },
  { label: "Specifications", to: "/robots/humanoid#specifications" },
];

const HumanoidTabs = () => {
  const { pathname } = useLocation();

  return (
    <nav
      aria-label="Humanoid sections"
      className="-mx-4 px-4 overflow-x-auto scrollbar-hide"
    >
      <ul className="flex w-max gap-2 pb-1">
        {TABS.map((t) => {
          const active =
            t.to === pathname ||
            (t.to.startsWith(pathname + "#") && pathname === "/robots/humanoid");
          const isCurrentPage = t.to === pathname;
          return (
            <li key={t.label}>
              <Link
                to={t.to}
                aria-current={isCurrentPage ? "page" : undefined}
                className={`inline-flex min-h-[44px] items-center whitespace-nowrap rounded-full border px-4 text-xs font-semibold tracking-wide uppercase transition-colors ${
                  isCurrentPage
                    ? "border-primary/50 bg-primary/15 text-primary"
                    : "border-[hsl(var(--line))] text-muted-foreground hover:text-foreground"
                } ${active && !isCurrentPage ? "text-foreground" : ""}`}
              >
                {t.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default HumanoidTabs;
